import 'animate.css/animate.css';
import 'morphext/dist/morphext.css';
import 'morphext/dist/morphext.js';

export default function() {
    $(".js-fliptext").Morphext({
        animation: "flipInX",
        speed: 5000,
        complete: function () {
            // console.log("This is called after a phrase is animated in! Current phrase index: " + this.index);
        }
    });
}